import { socialApiClient } from '@/shared/api-client/social-api-client';
import z from 'zod';

import { campaignDtoSchema, campaignTrackItemSchema, mapCampaignDtoToCampaign } from '../schema';

export const campaignDetailResponseSchema = z
  .object({
    ...campaignDtoSchema.shape,
    items: z.array(campaignTrackItemSchema),
  })
  .transform((response) => ({
    ...mapCampaignDtoToCampaign(response),
    items: response.items,
  }));

export type CampaignDetailData = z.infer<typeof campaignDetailResponseSchema>;

export async function FetchCampaignDetail(
  campaignId: string,
  signal?: AbortSignal,
): Promise<CampaignDetailData> {
  const response = await socialApiClient.get(`campaigns/${campaignId}`, {
    signal,
  });
  return campaignDetailResponseSchema.parse(await response.json());
}
